import { Component, OnInit, Input, inject } from '@angular/core';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedService } from '../../../services/shared.service';
import { BrandService } from '../../../services/brand/brand.service';

@Component({
    selector: 'app-brand-header',
    standalone: true,
    templateUrl: './brand-header.component.html',
    styleUrls: ['./brand-header.component.css'],
    imports: [ReactiveFormsModule]
})
export class BrandHeaderComponent implements OnInit {

  @Input() data: any;
  @Input() additionalParams?: Map<string,any>;

  private readonly sharedService = inject(SharedService);
  private readonly brandService = inject(BrandService);
  private readonly sanitizer = inject(DomSanitizer);

  brandName!: string;
  headerText!: string;
  brandLogoImage!: any;
  isBrandLogoImageShown: boolean = false;
  isHeaderTextShown: boolean = false;

  imageHeight: number = 150;

  innerHtml!: SafeHtml;
  isInnerHtmlShown: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.makeBrandHeader(this.data);
  }

  makeBrandHeader (brandInfo: IBrandInfo) {
    // Display the brand name
    this.brandName = brandInfo.brandName;
    if (brandInfo.sectionText) {
      this.headerText = brandInfo.sectionText;
      this.isHeaderTextShown = true;
    }
    // Display the brand logo image, if possible
    this.brandLogoImage = null;
    this.isBrandLogoImageShown = false;
    if (brandInfo.imageDescr) {
      this.brandLogoImage = 'data:' + brandInfo.imageDescr.imageType + ';base64,' + brandInfo.imageDescr.imageContent;
      this.isBrandLogoImageShown = true;
    }

    if (this.additionalParams) {
      if (this.additionalParams.has('useNonmobileBrandImage')) {
        let useNonmobileBrandImage: boolean = Boolean(this.additionalParams.get('useNonmobileBrandImage'));
        if (useNonmobileBrandImage) {
          this.getBrandImage(brandInfo.nonmobileImageUrl);
        }
      }
    }

    let isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
    let nonmobileImageHeight = this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_NONMOBILE_IMAGE_HEIGHT");
    let mobileImageHeight = this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_MOBILE_IMAGE_HEIGHT");
    if (isMobile && mobileImageHeight) {
       this.imageHeight = Number(mobileImageHeight);
    }else if (!isMobile && nonmobileImageHeight) {
       this.imageHeight = Number(nonmobileImageHeight);
    }

    // this.brandLogoImage = this.brandLogoImage.replace('http://','https://');

    if (this.brandLogoImage) {
      this.isBrandLogoImageShown = true;
    }

    // console.log("BrandHeaderComponent: WAL_PAGES_HEADER_BRAND_LOGO_SHOWN: " + this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_HEADER_BRAND_LOGO_SHOWN"));
    // A special case to hide the logo image of the brand
    if (this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_HEADER_BRAND_LOGO_SHOWN") === "false") {
      this.isBrandLogoImageShown = false;
    } 

    const rawInnerHtml = this.sharedService.getBrandConfigProperty(brandInfo, "WAL_PAGES_HEADER_TEXT");
    if (rawInnerHtml) {
      this.innerHtml = this.sanitizer.bypassSecurityTrustHtml(rawInnerHtml);
      this.isInnerHtmlShown = true;
    } 

  }

  private getBrandImage(imageUrl: string | undefined) {
    if (imageUrl) {
        this.brandService.getImageByUrl(imageUrl)
        .subscribe({
          next: (response) => {
            const reader = new FileReader();
            reader.onload = () => {
              this.brandLogoImage = reader.result as string;
            };
            reader.readAsDataURL(response);
          },
          error: (error) => {
          },
          complete: () => {
          }
        });
      }
  }


}
